import { ItemfluxObjectType } from '@/enum/ItemfluxObjectType'
import { AloBase, getDefaultAloBase } from './AloBase'


export interface AloMercurial  {        
    mrcCodic:string
    mrcPxFinalHt:number
    computingError?:string
}

export const getDefaultAloMercurial = ():AloMercurial => {
    return {        
        mrcCodic:"",
        mrcPxFinalHt:0
    }
}

export const cleanAloMercurial = (mercurial:AloMercurial) => {
    if(!mercurial) return
}